/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const getAccountMessage = (state) => state?.checkout?.payment?.account?.accountMessage;
export const getAccountCreationStatus = (state) => state?.checkout?.payment?.account?.inProgress;
export const getEmailOptInSubscribeStatus = (state) => state?.checkout?.payment?.account?.isSubscribe;
